module.exports = __webpack_public_path__ + "img/GAME_SOUNDLINK1.955abd11.jpg";